import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as myGlobal from '../../../global';
import { CookieService } from 'ngx-cookie-service';

@Injectable( {
    providedIn: 'root'
} )
export class PropertiesService {

    constructor( private http: HttpClient, private cookieService: CookieService ) {
    }

    getPropertyInfo() {
        const headers = new HttpHeaders( {
            [ myGlobal.CONTENT_TYPE ]: 'application/json',
            [ myGlobal.TOKEN ]: this.cookieService.get( 'Token' ),
            [ myGlobal.PROVIDER ]: this.cookieService.get( 'Provider' )
        } );

        const options = ( {headers: headers} );

        return this.http.get( myGlobal.PROPERTY_MANAGEMENT + '/' + 'me/properties?order_by=created_at&limit=2&order=asc', options );
    }

    updatePropertyInfo( property_id, model ) {
        const headers = new HttpHeaders( {
            [ myGlobal.CONTENT_TYPE ]: 'application/json',
            [ myGlobal.TOKEN ]: this.cookieService.get( 'Token' ),
            [ myGlobal.PROVIDER ]: this.cookieService.get( 'Provider' )
        } );

        const options = ( {headers: headers} );

        return this.http.put( myGlobal.PROPERTY_MANAGEMENT + '/' + 'properties' + '/' + property_id + '/'
            + model.user_id, model, options );
    }

    deletePropertyInfo( propertyId, userId ) {
        const headers = new HttpHeaders( {
            [ myGlobal.CONTENT_TYPE ]: 'application/json',
            /*[myGlobal.TOKEN]:this.cookieService.get('Token'),
            [myGlobal.PROVIDER]:this.cookieService.get('Provider') */
        } );

        const options = ( {headers: headers} );

        return this.http.delete( myGlobal.PROPERTY_MANAGEMENT + '/' + 'properties' + '/' + propertyId + '/' + userId, options );
    }

    createPropertyInfo( newProperty ) {
        const headers = new HttpHeaders( {
            [ myGlobal.CONTENT_TYPE ]: 'application/json',
            [ myGlobal.TOKEN ]: this.cookieService.get( 'Token' ),
            [ myGlobal.PROVIDER ]: this.cookieService.get( 'Provider' )
        } );

        const options = ( {headers: headers} );

        return this.http.post( myGlobal.PROPERTY_MANAGEMENT + '/' + 'properties', newProperty, options );
    }

}

